import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";
import { getRemember } from "../utils/refresh";

const axiosInstance = getAxiosInstance();

export const refresh = async () => {
  return new Promise((resolve, reject) => {
    const tokens = getTokens();
    const remember = getRemember();
    axiosInstance
      .post(
        "/api/refresh",
        {
          refresh_token: tokens?.refresh_token,
          remember,
        },
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
